// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"921f3442","180":"653a0197","409":"921f3442","712":"94ea7b6a"}[chunkId] + ".chunk.css";
};